/* eslint-disable no-alert */
import {
  useState, useRef, useContext, useEffect,
} from 'react';
import IdleTimer from 'react-idle-timer';
import firebase from '../../utils/firebase';
// CONTEXTS
import { AuthContext } from '../../context/AuthProvider';
import { AlertContext } from '../../context/AlertProvider';

const DEFAULT_TIMEOUT = 60 * 60 * 1000;

function Timer() {
  const { currentUser, user } = useContext(AuthContext);
  const { setAlertConfig } = useContext(AlertContext);

  const idleTimer = useRef(null);
  const [timeout, setTimeout] = useState(DEFAULT_TIMEOUT);

  const onIdle = () => {
    if (currentUser) {
      setAlertConfig({
        type: 'warning',
        text: 'Deslogado',
        child: 'Parece que você ficou muito tempo inativo!',
      });
      firebase.logout('Idle');
      alert(`
        A sessão atual será encerrada,
        Você ficou muito tempo inativo.
      `);
    }
  };

  const onActive = () => {
    setTimeout(DEFAULT_TIMEOUT);
  };

  useEffect(() => {
    if (currentUser && user?.uid) {
      const tOut = user.sessionTimeout ?? DEFAULT_TIMEOUT;
      if (tOut === 0) idleTimer.current?.pause();
      else {
        idleTimer.current?.resume();
      }
      setTimeout(tOut);
    } else {
      idleTimer.current?.resume();
      onActive();
    }
  }, [user?.uid, currentUser]);

  return (
    <>
      <IdleTimer
        startOnMount
        ref={idleTimer}
        element={document}
        onIdle={onIdle}
        onActive={onActive}
        onAction={() => window.localStorage.setItem('lastActionTime', idleTimer.current?.getLastActiveTime())}
        debounce={250}
        timeout={timeout}
      />
    </>
  );
}
export default Timer;
